<template>
  <div class="py-10">
    <Sidebar></Sidebar>
    <Header>{{ minor.name }} {{ minor.surname }}</Header>
    <div class="bg-pink py-8 px-10 text-center block">
      <div class="container mx-auto">
        <div class="flex items-baseline">
          <router-link
            v-if="chkUserInfo('tutor')"
            class="flex-initial no-underline  mr-5"
            :to="{name: 'Genitori', params:{'id':id}}"
          ><i class="fas fa-cog p-3 rounded-full text-white bg-blue-dark shadow align-middle"></i></router-link>
          <div class="relative flex-1">
            <div
              class="w-10 h-10 absolute rounded-full z-1 -mt-12 -ml-12"
              :class="'bg-' + evaluateMinor"
              style="top:50%; left:50%;"
            ></div>
            <img
              class="w-24 h-24 rounded-full border-4 align-middle z-3 relative"
              :class="'border-' + evaluateMinor"
              src="/img/user.png"
            >
          </div>
          <div class="flex-initial">
            <i
              v-if="chkUserInfo('tutor')"
              class=" fas fa-qrcode p-3 rounded-full text-white bg-pink-dark shadow align-middle ml-5"
            ></i>
          </div>
        </div>
      </div>
    </div>
    <div class="bg-white pb-10 px-4">
      <div class="container mx-auto pt-4 px-4">
        <div class="text-right">
          <i
            class="fas fa-check text-green"
            @click="editMinor"
          ></i>
        </div>
        <div class="py-3 border-b-2 border-dashed border-pink mb-3">
          <h2 class="text-blue-dark text-sm"><b>{{$t('all.kids_time')}}</b></h2>
          <h3 class="text-blue-dark text-xs py-2"><b>{{$t('all.generica')}}</b></h3>
          <p class="text-sm">{{$t('all.kids_accompanied')}}</p>
          <div
            class="pt-8 pb-4"
            id="slider-area"
            v-if="showGenerica"
          >
            <vue-slider
              v-bind="generica"
              ref="sliderGenerica"
              v-model="minor.arrival_time"
            >
              <template
                slot="tooltip"
                scope="tooltip"
              >
                <div class="custom-tooltip text-grey text-sm">
                  {{ tooltip.value }}
                </div>
              </template>
            </vue-slider>
          </div>
          <div v-if="!special">
            <p
              class="text-sm"
              @click="addSpecial()"
            >{{$t('all.common_add_special')}}</p>
          </div>
          <div v-if="special">
            <div @click="addSpecial()">
              <h4 class="text-sm py-2">{{$t('all.common_special')}}</h4>
              <p class="text-sm">{{$t('all.common_daily_validity')}}</p>
            </div>
            <div
              class="pt-8 pb-4"
              id="slider-area"
            >
              <vue-slider
                v-bind="speciale"
                ref="sliderSpeciale"
                v-model="speciale.value"
              >
                <template
                  slot="tooltip"
                  scope="tooltip"
                >
                  <div class="custom-tooltip text-grey text-sm">
                    {{ tooltip.value }}
                  </div>
                </template>
              </vue-slider>
            </div>
          </div>
        </div>
        <h4 class="pb-2 text-blue-dark">{{$t('all.profile_data')}}</h4>
        <div class="flex">
          <div class="flex-1">
            <p class="pb-2">
              <i class="text-xs">{{$t('all.common_birthday')}}</i><br>
              <input
                class="p-2 w-9/10"
                type="text"
                v-model="minor.birth_date"
                name="birth_date"
              >
            </p>
            <p class="pb-2">
              <i class="text-xs">{{$t('all.common_province')}}</i><br>
              <input
                class="p-2 w-9/10"
                type="text"
                v-model="minor.province"
                name="provincia"
              >
            </p>
          </div>
          <div class="flex-1">
            <p class="pb-2 text-right">
              <i class="text-xs">{{$t('all.common_birthplace')}}</i><br>
              <input
                class="p-2 w-9/10 text-right"
                type="text"
                v-model="minor.hometown"
                name="hometown"
              >
            </p>
            <p class="pb-2 text-right">
              <i class="text-xs">{{$t('all.common_citizenship')}}</i><br>
              <input
                class="p-2 w-9/10 text-right"
                type="text"
                v-model="minor.citizenship"
                name="nazionalita"
              >
            </p>
          </div>
        </div>
        <div>
          <p class="pb-2">
            <i class="text-xs">{{$t('all.profile_fiscal_code')}}</i><br>
            <input
              class="p-2 w-full"
              type="text"
              v-model="minor.fiscal_code"
              name="cf"
              disabled
            >
          </p>
        </div>
        <h5 class="py-2  text-blue-dark">{{$t('all.common_resident')}}</h5>
        <div class="flex">
          <div class="flex-1">
            <p class="pb-2">
              <i class="text-xs">{{$t('all.common_city')}}</i><br>
              <input
                class="p-2 w-9/10"
                type="text"
                v-model="minor.residence_city"
                name="city"
              >
            </p>
            <p class="pb-2">
              <i class="text-xs">{{$t('all.common_street_number')}}</i><br>
              <input
                class="p-2 w-9/10"
                type="text"
                v-model="minor.street_number"
                name="civico"
              >
            </p>
          </div>
          <div class="flex-1">
            <p class="pb-2 text-right">
              <i class="text-xs">{{$t('all.common_street')}} / {{$t('all.common_fraction')}}</i><br>
              <input
                class="p-2 w-9/10 text-right"
                type="text"
                v-model="minor.street"
                name="via"
              >
            </p>
            <p class="pb-2 text-right">
              <i class="text-xs">{{$t('all.common_postal')}}</i><br>
              <input
                class="p-2 w-9/10 text-right"
                type="text"
                v-model="minor.zip_code"
                name="cap"
              >
            </p>
          </div>
        </div>
        <h5 class="py-2 text-blue-dark">{{$t('all.common_special_info')}}</h5>
        <div class="flex">
          <div class="flex-1">
            <p class="pb-2">
              <i class="text-xs">{{$t('all.kids_allergies')}}</i><br>
              <input
                class="p-2 w-9/10 "
                type="text"
                v-model="minor.intolerance"
                name="intolerance"
              >
            </p>
          </div>
          <div class="flex-1">
            <p class="pb-2 text-right">
              <i class="text-xs">{{$t('all.common_diseases')}}</i><br>
              <input
                class="p-2 w-9/10 text-right"
                type="text"
                v-model="minor.pathologies"
                name="pathologies"
              >
            </p>
          </div>
        </div>
        <div>
          <p class="pb-2">
            <i class="text-xs">{{$t('all.common_notes')}}</i><br>
            <input
              class="p-2 w-full"
              type="text"
              v-model="minor.notes"
              name="notes"
            >
          </p>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import vueSlider from 'vue-slider-component';
import moment from 'moment';
import { authService } from '@/services';
import { mapGetters, mapActions } from 'vuex';
import { evaluateMinor } from '@/mixins/minore.mixins';

function getRangeOfDates(start, end, key, arr = [start.startOf(key)]) {
  if (start.isAfter(end)) throw new Error('start must precede end');

  const next = moment(start)
    .add(10, key)
    .startOf(key);

  if (next.isAfter(end, key)) return arr;

  return getRangeOfDates(next, end, key, arr.concat(next));
}

export default {
  props: ['id'],
  mixins: [evaluateMinor],
  components: {
    vueSlider,
  },
  data() {
    return {
      showGenerica: false,
      special: false,
      excId: null,
      generica: {
        value: '08:00',
        height: 4,
        dotSize: 18,
        show: true,
        tooltip: 'always',
        data: null,
      },
      speciale: {
        value: '08:00',
        dotSize: 18,
        height: 4,
        show: true,
        tooltip: 'always',
        data: null,
      },
    };
  },
  computed: {
    ...mapGetters({
      showTutorContact: 'authentication/showContact',
      isFamilyAdmin: 'users/isFamilyAdmin',
      getClassName: 'users/getClassName',
      getDateException: 'users/getDateException',
      exception: 'users/getException',
      minor: 'users/minor',
      userInfo: 'authentication/userInfo',
    }),
  },
  methods: {
    ...mapActions('users', [
      'getMinor',
      'updateArrivalExc',
      'addArrivalExc',
      'updateMinor',
    ]),
    ...mapActions('authentication', ['getUserInfo']),
    rangeData() {
      this.showGenerica = false;
      if (!this.minor || !this.minor.classroom) {
        return [];
      }
      const arrivalTime = this.minor.classroom.arrival_time;
      const leavingTime = this.minor.classroom.leaving_time;
      const [arrivalTimeHour, arrivalTimeMinutes] = arrivalTime.split(':');
      const [leavingTimeHour, leavingTimeMinutes] = leavingTime.split(':');

      const classOpen = moment().set({
        hour: parseInt(arrivalTimeHour, 10),
        minute: parseInt(arrivalTimeMinutes, 10),
      });
      const classEnd = moment().set({
        hour: parseInt(leavingTimeHour, 10),
        minute: parseInt(leavingTimeMinutes, 10),
      });
      const range = getRangeOfDates(classOpen, classEnd, 'minute');
      this.speciale.data = range.map(momentDate => momentDate.format('HH:mm'));
      this.generica.data = range.map(momentDate => momentDate.format('HH:mm'));
      this.showGenerica = true;
      return '';
    },
    chkUserInfo(role) {
      return this.isFamilyAdmin && authService.hasRole(role);
    },
    addSpecial() {
      this.special = !this.special;
    },
    setDateException() {
      if (!this.exception) {
        return;
      }
      this.excId = this.exception.id;
      this.special = true;
      this.speciale.value = this.getDateException;
    },
    editMinor() {
      const vm = this;
      const { id } = this;
      const minor = this.minor;
      const classroom = minor.classroom.id;
      const arrival = this.speciale ? this.speciale.value : null;
      delete minor.created_at;
      delete minor.updated_at;
      if (this.special && arrival && minor.arrival_time_today !== arrival) {
        if (this.excId != null) {
          const excId = this.excId;
          this.updateArrivalExc({ excId, arrival });
        } else {
          this.addArrivalExc({
            id,
            classroom,
            arrival,
          }).then(() => vm.setDateException());
        }
      }
      this.updateMinor({ user: minor });
    },
  },
  async created() {
    const self = this;
    await this.getUserInfo();
    const { id } = this;
    const role = authService.getRole();
    await this.getMinor({ id, role });
    this.rangeData();
    this.setDateException();
  },
};
</script>
